import { useEffect} from "react"
import { useDispatch, useSelector } from "react-redux"
import { selectSavedReceivers, selectSavedReceiversErrors, selectSavedReceiversStatuses, setUnauthorized, uploadSavedReceivers } from "./savedReceiversSlice"
import SavedReceiversList from "./SavedReceiversList"
import { requireAuthentication } from "../authentication/authSlice"
import { useTranslation } from "react-i18next"

const SavedReceiversPage = () => {
    const {t} = useTranslation()
    const dispatch = useDispatch()
    
    const savedReceivers = useSelector(selectSavedReceivers)
    const savedReceiversStatuses = useSelector(selectSavedReceiversStatuses)
    const savedReceiversErrors = useSelector(selectSavedReceiversErrors)
    const unauthorized = useSelector(state => state.savedReceivers.unauthorized)

    useEffect(() => {
        dispatch(uploadSavedReceivers())
    }, [dispatch])

    useEffect(() => {
        if(unauthorized) {
            dispatch(requireAuthentication())
            dispatch(setUnauthorized(false))
        }   
    }, [dispatch, unauthorized])


    
    return (
    <div>
        {savedReceiversStatuses.uploading === "pending" && <div>Loading...</div>}
        {savedReceiversStatuses.uploading === "rejected" && <div>Error: {savedReceiversErrors.uploadSavedReceivers}</div>}
        {savedReceiversStatuses.uploading === "fulfilled" && 
        
        <div className="block w-full border mx-auto p-4 shadow-2xl rounded-xl">    
            <header className="text-center font-medium mb-4">
                {savedReceivers?.length === 0 && t("saved_receivers.no_saved_receivers")}
                {savedReceivers?.length > 0 &&  t("saved_receivers.saved_receivers_list")}
            </header>
            <main>
                <SavedReceiversList receivers={savedReceivers} />
            </main>
        </div>}    
    </div>
  )
}

export default SavedReceiversPage